import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Reason } from '../../../../../models/loyalty-reason.model';
import { KontableComponent } from '../../../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyMovementService } from '../../../../../services/loyalty/loyalty-movement.service';
import { AuthService } from './../../../../../services/user/auth.service';

@Component({
  selector: 'kv-customer-loyalty-movements',
  template: `
    <div class="ui-dialog-content ui-g-12" *ngIf="labels">
      <app-kontable
                    id="kon_movements"
                    title="{{ 'customers.loyalty_movements' | translate }}"
                    [columns]="['card_no',
                    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: selectFilter, filterOptions: {values: listMovementStatus}},
                    { field: 'reasonDescription', title: 'customers.reason_id' },
                    'store_name',
                    { field: 'xact_date', title: 'customers.movement_xact_date', bodyTemplate: xactDateTemplate },
                    { field: 'xact_time', title: 'customers.movement_xact_time', bodyTemplate: xactTimeTemplate },
                    {field: 'value', title: 'extClusterAnalytics.value'}
                    ]"
                    [titles]="['customers.card_no',
                    'customers.movement_store_id',
                    'common.store_name'
                    ]"
                    [source]="accumulatorMovements"
                    [showGlobalFilter]="false"
                    [showDetailsButton]="false"
                    [showInfoButton]="false"
                    [showRecoverButton]="false"
                    [showAddButton]="false"
                    [showEditButton]="false"
                    [showDeleteButton]="false"
                    [paginationType]="paginationType"
      >

      <ng-template #stateTemplate let-row>
        <span *ngIf="row.flg_state && row.flg_state == '0'">{{labels.status_notDeleted}}</span>
        <span *ngIf="row.flg_state && row.flg_state == '1'">{{labels.status_onlyDeleted}}</span>
        <span *ngIf="row.flg_state && row.flg_state == '2'">{{labels.status_onlySuspended}}</span>
      </ng-template>

        <ng-template #xactDateTemplate let-row>
          <span *ngIf="selectedLanguage != 'it'">{{row['xact_date'] | date: 'yyyy-MM-dd'}}</span>
          <span *ngIf="selectedLanguage == 'it'">{{row['xact_date'] | date: 'dd/MM/yyyy'}}</span>
        </ng-template>

        <!-- <ng-template #statusTemplate let-col>
          <span>{{row['xact_date'] | date: 'yyyy-MM-dd'}}</span>
        </ng-template> -->

        <ng-template #xactTimeTemplate let-row>
          {{convertTime(row['xact_time'])}}
        </ng-template>
      </app-kontable>

    </div>
  `,
  styles: [`
    .ui-dialog {
      width: 800px;
      height: 500px;
      overflow: scroll;
    }
  `]
})
export class MovementsDialogComponent implements OnChanges {

  @Input() accumulatorId: number;
  @Input() customerHostId: number;
  @Input() cardNo: string;
  accumulatorMovements: any;
  reasons: Reason[];
  paginationType = KontableComponent.ClientPagination;
  listMovementStatus = new Array<{label: string, value: string}>();
  labels = null
  selectFilter = KontableComponent.SelectFilter;
  selectedLanguage: string;

  constructor(private svcLoyMovements: LoyaltyMovementService,
              private translate: TranslateService,
              private authSrv: AuthService) {
  }

  ngOnInit() {

    this.svcLoyMovements.getTopMovementsByAccumulatorId(this.accumulatorId, this.customerHostId, this.cardNo).subscribe(data => {
      this.accumulatorMovements = data['data']
    })

    this.selectedLanguage = this.authSrv.sessionHelper.selectedLanguage;

    this.translate.get([
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended'
    ]).subscribe((res) => {

      this.labels = {
        all: '',
        status_notDeleted:  res['common.status_notDeleted'],
        status_onlyDeleted: res['common.status_onlyDeleted'],
        status_onlySuspended: res['common.status_onlySuspended']
      }

      this.listMovementStatus.push(
        {label: this.labels.all, value: null},
        {label: this.labels.status_notDeleted, value: '0'},
        {label: this.labels.status_onlyDeleted, value: '1'},
        {label: this.labels.status_onlySuspended, value: '2'}
        );
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['accumulatorId'] && changes['accumulatorId'].currentValue) {}
  }

  convertTime(time: string): string {
    if (!time) return '';
    return time.split('.')[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/movementsDialog.component.ts